export default __webpack_public_path__ + "static/mindscapeLogo-87355f293abe10274fb24c63db35df79.png";